module.exports = __webpack_public_path__ + "img/visa.a444d93.png";